export default class Video {
  constructor(item, lang) {
    this._setId(item);
    this._setTitle(item, lang);
    this._setDescription(item, lang);
    this._setImage(item, lang);
    this._setVideo(item, lang);
  }

   /**
   * set id
   * @param {id} param0
   */
    _setId({ id }) {
      this.id = id;
    }
    
  /**
   * set title
   * @param {video} item
   * @param {language} lang
   */
  _setTitle(item, lang) {
    let key = "title_" + lang;
    this.title = item[key];
  }

  /**
   * set description
   * @param {video} item
   * @param {language} lang
   */
  _setDescription(item, lang) {
    let key = "description_" + lang;
    this.description = item[key];
  }

  /**
   * set image — prefer per-language poster, fall back to default
   */
  _setImage(item, lang) {
    const langKey = "photoUrl_" + lang;
    this.image = item[langKey] || item.photoUrl;
  }

  /**
   * set video — prefer per-language video, fall back to default
   */
  _setVideo(item, lang) {
    const langKey = "videoUrl_" + lang;
    this.video = item[langKey] || item.videoUrl;
  }
}
